/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Fields/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Description from './Description/index'
import Number from './Number/index'
import React from 'react'
import Type from './Type/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Fields({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Phone/Phones/Content/Phone/Edit/Content/Fields"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="Fields.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Fields.Vertical"
  data-view-path={viewPath}
 style={{'--pr-1-2tX3iC': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<Number
  viewPath={`${viewPath}/Number`}
/>
</div>
<div
  data-testid="Fields.Vertical:1"
  data-view-path={viewPath}
 style={{'--pl-2-2tX3iC': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical1}`}
>
<Type
  viewPath={`${viewPath}/Type`}
/>
</div>
</div>
<Description
  viewPath={`${viewPath}/Description`}
/>
{children}
</React.Fragment>)
}